import { render, staticRenderFns } from "./IndexCustomerPage.vue?vue&type=template&id=de5a281a&"
import script from "./IndexCustomerPage.vue?vue&type=script&lang=js&"
export * from "./IndexCustomerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports